const CLICK = 'click';
const IMPRESSION = 'impression';

export const PRODUCT_LIST_IMPRESSION = {
  eid: 'product_list.impression',
  type: IMPRESSION
};

export const SORT_DROPDOWN_IMPRESSION = {
  eid: 'sort_dropdown.impression',
  type: IMPRESSION
};

export const SORT_DROPDOWN_DESCEND_BY_POPULARITY_CLICK = {
  eid: 'sort_dropdown.descend_by_popularity.click',
  type: CLICK
};

export const SORT_DROPDOWN_DESCEND_BY_CREATED_AT_CLICK = {
  eid: 'sort_dropdown.descend_by_created_at.click',
  type: CLICK
};

export const SORT_DROPDOWN_ASCEND_BY_PRICE_CLICK = {
  eid: 'sort_dropdown.ascend_by_price.click',
  type: CLICK
};

export const SORT_DROPDOWN_DESCEND_BY_PRICE_CLICK = {
  eid: 'sort_dropdown.descend_by_price.click',
  type: CLICK
};

export const SORT_DROPDOWN_ASCEND_BY_NAME_CLICK = {
  eid: 'sort_dropdown.ascend_by_name.click',
  type: CLICK
};

export const SORT_DROPDOWN_DESCEND_BY_NAME_CLICK = {
  eid: 'sort_dropdown.descend_by_name.click',
  type: CLICK
};

export const CATEGORY_LIST_CATEGORY_CLICK = {
  eid: 'category_list.category.click',
  type: CLICK
};

export const PRODUCT_LIST_PRODUCT_CLICK = {
  eid: 'product_list.product.click',
  type: CLICK
};

export const PAGINATION_IMPRESSION = {
  eid: 'pagination.impression',
  type: IMPRESSION
};

export const PAGINATION_PAGE_NUMBER_CLICK = {
  eid: 'pagination.page_number.click',
  type: CLICK
};

export const PAGINATION_ARROW_CLICK = {
  eid: 'pagination.arrow.click',
  type: CLICK
};

export const PRODUCT_LIST_SALE_RIBBON_PRODUCT_IMPRESSION = {
  eid: 'product_list.sale_ribbon_product.impression',
  type: IMPRESSION
};

export const PRODUCT_LIST_SALE_RIBBON_PRODUCT_CLICK = {
  eid: 'product_list.sale_ribbon_product.click',
  type: CLICK
};

export const PRODUCT_LIST_LIMITED_EDITION_EYEBROW_PRODUCT_IMPRESSION = {
  eid: 'product_list.limited_edition_eyebrow_product.impression',
  type: IMPRESSION
};

export const PRODUCT_LIST_LIMITED_EDITION_EYEBROW_PRODUCT_CLICK = {
  eid: 'product_list.limited_edition_eyebrow_product.click',
  type: CLICK
};

export const PRODUCT_LIST_FREE_SHIPPING_EYEBROW_PRODUCT_IMPRESSION = {
  eid: 'product_list.free_shipping_eyebrow_product.impression',
  type: IMPRESSION
};

export const PRODUCT_LIST_FREE_SHIPPING_EYEBROW_PRODUCT_CLICK = {
  eid: 'product_list.free_shipping_eyebrow_product.click',
  type: CLICK
};

export const PRODUCT_DETAIL_LAYOUT_1_IMPRESSION = {
  eid: 'product_detail.layout_1.impression',
  type: IMPRESSION
};

export const PRODUCT_DETAIL_LAYOUT_2_IMPRESSION = {
  eid: 'product_detail.layout_2.impression',
  type: IMPRESSION
};

export const IMAGE_THUMBNAIL_CLICK = {
  eid: 'image_thumbnail.click',
  type: CLICK
};

export const SIMILAR_PRODUCTS_IMPRESSION = {
  eid: 'similar_products.impression',
  type: IMPRESSION
};

export const SIMILAR_PRODUCTS_PRODUCT_CLICK = {
  eid: 'similar_products.product.click',
  type: CLICK
};

export const COMING_SOON_MODAL_IMPRESSION = {
  eid: 'coming_soon_modal.impression',
  type: IMPRESSION
};

export const PRODUCT_DETAIL_PAGE_ADD_TO_CART_CTA_CLICK = {
  eid: 'product_detail_page.add_to_cart_cta.click',
  type: CLICK
};

export const OUT_OF_STOCK_PRODUCT_IMPRESSION = {
  eid: 'out_of_stock_product.impression',
  type: IMPRESSION
};

export const OUT_OF_STOCK_PRODUCT_CLICK = {
  eid: 'out_of_stock_product.click',
  type: CLICK
};

export const OLS_CART_VIEW = ({ loggedIn, cartSize }) => {
  return {
    eid: 'OLS.CART_VIEW',
    type: CLICK,
    params: [
      ['Logged in', loggedIn],
      ['Cart size', cartSize]
    ]
  };
};

export const OLS_CART_REMOVEITEM = ({ productType, beginningCartSize }) => {
  return {
    eid: 'OLS.CART_REMOVEITEM',
    type: CLICK,
    params: [
      ['Product type', productType],
      ['Beginning cart size', beginningCartSize]
    ]
  };
};

export const OLS_CART_ADJUST_ITEM_QTY = ({ adjustedQty, beginningQty }) => {
  return {
    eid: 'OLS.CART_ADJUST_ITEM_QTY',
    type: CLICK,
    params: [
      ['Adjusted Qty', adjustedQty],
      ['Beginning Qty', beginningQty]
    ]
  };
};

export const OLS_CART_UPDATE = {
  eid: 'OLS.CART_UPDATE',
  type: CLICK
};

export const OLS_CART_APPLYCOUPON = ({ valid }) => {
  return {
    eid: 'OLS.CART_APPLYCOUPON',
    type: CLICK,
    params: [['Valid', valid]]
  };
};

export const OLS_CART_CONTINUE_SHOPPING = ({ beginningCartSize }) => {
  return {
    eid: 'OLS.CART_CONTINUE_SHOPPING',
    type: CLICK,
    params: [['Beginning cart size', beginningCartSize]]
  };
};
